import { Component, OnInit, Renderer2, HostListener } from "@angular/core";
import { ConfirmationService, MessageService, MenuItem } from "primeng/api";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "src/app/services/auth.service";
import { UserService } from "../../../../services/user.service";
import { StateService } from "src/app/manage/state/service/state.service";
import { CityService } from "src/app/manage/city/service/city.service";
import { CustomValidators } from "ng2-validation";
import { CommonService } from "../../../../services/common.service";
import { environment } from "src/environments/environment";
import { MustMatch } from "../../../../_helpers/must-match.validator";
//import * as moment from 'moment';
import { TokenStorageService } from "src/app/services/token-storage.service";
import * as moment from "moment-timezone";
import * as CryptoJS from "crypto-js";

@Component({
  selector: "app-kycForm",
  templateUrl: "./kycForm.component.html",
  styleUrls: ["./kycForm.component.scss"],
  providers: [ConfirmationService, MessageService],
})
export class KycFormComponent implements OnInit {
  items: MenuItem[];
  id;
  public loggedInUser;
  public isLoggedIn: boolean;
  public userId;
  kycUpdateForm: FormGroup;
  kycUpdateForm2: FormGroup;
  public submittedKyc: boolean;
  submitted: boolean = false;
  submitted2: boolean = false;
  showMessage: boolean = false;
  public isVerified: boolean;
  public cityList: any[] = [];
  public selectedCityId;
  public selectedCityName;
  public stateList: any[] = [];
  public countryName;
  public countryCode;
  public stateName;
  public stateCode;
  public cityName;
  public cityCode;
  public imageProfile;
  public panCardImage;
  showProfile = false;
  public count;
  uploadedFiles: any[] = [];
  public item: any[] = [];
  kycId: any;
  step: number = 0;
  activeIndex: number = 0;
  oldstep: number = 0;
  address: any;
  gstNumber: any;
  bankName: any;
  ifsc: any;
  accountNumber: any;
  hide: boolean = false;
  isAcademy: boolean = false;
  atleastOneMandatory: boolean = false;
  selectedCardType: any = "Pancard";
  private key = CryptoJS.enc.Utf8.parse(environment.EncryptKey);
  private iv = CryptoJS.enc.Utf8.parse(environment.EncryptIV);
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private commonService: CommonService,
    private stateService: StateService,
    private cityService: CityService,
    private tokenStorage: TokenStorageService,
    private authService: AuthService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private renderer: Renderer2,

  ) { }
  cardType: any[] = [
    { name: 'Pancard', key: 'P' },
    { name: 'Aadharcard', key: 'A' }
  ];
  async ngOnInit(): Promise<void> {
    this.kycId = this.route.snapshot.paramMap.get("kycId");
    this.oldstep = Number(this.route.snapshot.paramMap.get('step'));
    if (this.oldstep != undefined) {
      this.step = this.oldstep;
      this.activeIndex = this.oldstep;
    }
    this.items = [{
      label: 'DOCUMENT DETAILS',
      command: (event: any) => {
        this.activeIndex = 0;
        this.messageService.add({ severity: 'info', summary: 'First Step', detail: event.item.label });
      }
    },
    {
      label: 'BANK DETAILS',
      command: (event: any) => {
        this.activeIndex = 1;
        this.messageService.add({ severity: 'info', summary: 'Seat Selection', detail: event.item.label });
      }
    },

    {
      label: 'COMPLETED',
      command: (event: any) => {
        this.activeIndex = 2;
        this.messageService.add({ severity: 'info', summary: 'Seat Selection', detail: event.item.label });
      }
    },

    ];

    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.isLoggedIn = true;
      this.userId = this.loggedInUser.userdata.id;
    }
    let roleName = this.loggedInUser.userdata.rolename;
    if (roleName == "academy") {
      this.isAcademy = true;
    }
    if (this.isLoggedIn == false) {
      this.router.navigate(["/"]);
    }
    this.id = this.userId;
    await this.getStates();


    this.kycUpdateForm = this.formBuilder.group(
      {
        panOrAadhar: ["", { validators: [Validators.required], updateOn: "blur" }],
        panCardNumber: [""],
        adharCardNumber: [null],
        gstNumber: ["", { validators: [Validators.pattern("[0-9]{2}[A-Za-z]{3}[CPHFATBLJGcphfatblj]{1}[A-Za-z]{1}[0-9]{4}[A-Za-z]{1}[0-9A-Za-z]{1}(Z|z)[0-9A-Za-z]{1}"),], updateOn: "blur", },],
        address: [""],
        state: ["", { validators: [Validators.required], updateOn: "blur", },],
        city: ["", { validators: [Validators.required], updateOn: "blur", },],
        zipcode: ["", { validators: [Validators.required], updateOn: "blur", },]
      },);

    this.kycUpdateForm2 = this.formBuilder.group(
      {
        bankName: ["", { validators: Validators.required, updateOn: "blur", },],
        accountNumber: [null, { validators: [Validators.required, Validators.pattern('^[0-9]{9,18}$')], updateOn: "blur", },],
        confirmAccountNumber: ["", { validators: Validators.required, updateOn: "blur", },],
        ifsc: ["", { validators: [Validators.required, Validators.pattern("^[A-Za-z]{4}0[A-Z0-9a-z]{6}$"),], updateOn: "blur", },],
      }, {
      validator: MustMatch("accountNumber", "confirmAccountNumber"),
    });

    this.renderer.addClass(document.body, 'kyc-page');
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'kyc-page');
  }
  onCardTypeSelect(cardType) {
    this.selectedCardType = cardType;
    this.kycUpdateForm.get("panOrAadhar").disable();
  }
  onActiveIndexChange(event) {
    if (event == 0) {
      this.step = 0;
      this.activeIndex = 0;
      // if (this.isTournamentCreate == false) {
      //   this.tournamentform.get('enddate').setErrors(null);
      // }
    }
    else if (event == 1) {
      this.step = 1;
      this.activeIndex = 1;
    } else if (event == 2) {
      this.activeIndex = 2;
      this.step = 2;
    }
  }
  next() {
    if (this.kycId != null) {
      this.step = this.step + 1;
      this.activeIndex = this.activeIndex + 1;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate(['/kyc-update/' + this.kycId + "/" + this.step]);
    }
  }
  previous() {
    //console.log("before: " + this.step + "   " + this.activeIndex);
    this.step = this.step - 1;
    this.activeIndex = this.activeIndex - 1;
    // console.log("After: " + this.step + "   " + this.activeIndex);
    // console.log('/createtournament/' + this.tournamentId + "/" + this.step);
    // if (this.step == 0) {
    //   this.kycUpdateForm.get('enddate').setErrors(null);
    // }
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(["/kyc-update/" + this.kycId + "/" + this.step]);
  }
  get f() {
    return this.kycUpdateForm.controls;
  }
  get f2() {
    return this.kycUpdateForm2.controls;
  }


  onCitySelect(event) {
    this.selectedCityId = undefined;
    this.selectedCityName = undefined;
    if (event.value) {
      this.selectedCityId = event.value.code;
      this.selectedCityName = event.value.name;
    }
  }
  async getStates() {
    this.stateList = [];
    this.stateCode = "";
    this.stateName = "";
    this.cityList = [];
    this.cityCode = "";
    this.cityName = "";
    let countryCode = "IN";
    let query =
      "filterByDisable=false&orderBy=name&sortBy=1&filterByCountryCode=" +
      countryCode;
    this.stateService.getstateList(query).subscribe(async (res) => {
      if (res.data.items.length > 0) {
        res.data.items.forEach((element) => {
          let stateObj = {
            name: element.name,
            id: element.id,
          };
          this.stateList.push(stateObj);
        });
      }
      if (this.route.snapshot.params.kycId != undefined) {
        await this.getkyc(this.route.snapshot.params.kycId);
      } else {
        this.submittedKyc = true;
      }
    });
  }

  getCities(fromForm, event) {
    this.cityCode = "";
    this.cityName = "";
    if (fromForm == "true") {
      this.stateCode = event.value.id;
      this.stateName = event.value.name;
    } else {
      this.stateCode = event;
    }

    this.commonService.getCityList(this.stateCode).subscribe(
      (data) => {
        this.cityList = data.data.items;
      },
      (err) => {
        // this.errorMessage = err.error.message;
      }
    );
  }
  picUploader(event) {
    for (let file of event.files) {
      this.uploadedFiles.push(file);
      var reader = new FileReader();
      reader.readAsDataURL(this.uploadedFiles[0]);
      reader.onload = () => {
        // called once readAsDataURL is completed
        this.panCardImage = reader.result;
      };
    }
  }

  onSubmit(): void {
    this.submitted = true;

    //stop here if form is invalid
    // console.log(this.kycUpdateForm)
    const panCardValue = this.kycUpdateForm.get('panCardNumber').value;
    const adharCardValue = this.kycUpdateForm.get('adharCardNumber').value;
    if (this.selectedCardType == 'Pancard') {
      this.kycUpdateForm.controls.adharCardNumber.setValue(null);
      this.kycUpdateForm.controls['panCardNumber'].setValidators([Validators.pattern('[A-Za-z]{3}[PCHFATBLJGpchfatbljg]{1}[A-Za-z]{1}[0-9]{4}[A-Za-z]{1}$')]);
      this.kycUpdateForm.controls.panCardNumber.updateValueAndValidity();
      if (!panCardValue) {
        // console.log("in")
        this.atleastOneMandatory = true
        return
      }
    }
    if (this.selectedCardType == 'Aadharcard') {
      this.kycUpdateForm.controls.panCardNumber.setValue("");
      this.kycUpdateForm.controls['adharCardNumber'].setValidators([Validators.pattern('[0-9]{12}'), Validators.minLength(12)]);
      this.kycUpdateForm.controls.adharCardNumber.updateValueAndValidity();
      if (!adharCardValue) {
        // console.log("in")
        this.atleastOneMandatory = true
        return
      }
    }
    if (panCardValue || adharCardValue) {
      // console.log("out")
      this.atleastOneMandatory = false
    }


    if (this.kycUpdateForm.invalid) {
      return;
    }

    let documentData = this.kycUpdateForm.value;
    if (documentData.panOrAadhar == 'Pancard') {
      delete documentData["adharCardNumber"];
      //  documentData["panCardNumber"]=CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(documentData["panCardNumber"]), this.key, {
      //   keySize: 128 / 8,
      //   iv: this.iv,
      //   mode: CryptoJS.mode.CBC,
      //   padding: CryptoJS.pad.Pkcs7
      // }).toString();
    }
    else if (documentData.panOrAadhar == 'Aadharcard') {
      delete documentData["panCardNumber"];
      //  documentData["adharCardNumber"]=CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(documentData["adharCardNumber"]), this.key, {
      //   keySize: 128 / 8,
      //   iv: this.iv,
      //   mode: CryptoJS.mode.CBC,
      //   padding: CryptoJS.pad.Pkcs7
      // }).toString();
    }
    if (this.panCardImage !== "{{imageProfile}}") {
      documentData["panCardImage"] = this.panCardImage;
    }
    documentData["statename"] = this.stateName;
    documentData["statecode"] = this.stateCode;
    documentData["citycode"] = this.selectedCityId;
    documentData["cityname"] = this.selectedCityName;
    // documentData["gstNumber"]=CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(documentData["gstNumber"]), this.key, {
    //   keySize: 128 / 8,
    //   iv: this.iv,
    //   mode: CryptoJS.mode.CBC,
    //   padding: CryptoJS.pad.Pkcs7
    // }).toString();
    console.log(documentData)
    if (this.kycId == undefined) {

      this.submittedKyc = true;
      this.userService.addUserKyc(documentData).subscribe(
        (data) => {
          let kycId = data.id.insertedId;
          this.showMessage = true;
          this.submitted = false;

          if (kycId != undefined) {
            this.step = this.step + 1;
            this.activeIndex = this.activeIndex + 1;
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = "reload";
            this.router.navigate(["/kyc-update/" + kycId + "/" + this.step]);
          }
        },
        (err) => {
          console.log(err);
          this.messageService.add({
            key: "toastmsg",
            severity: "error",
            summary: "Error",
            detail: err.error.message,
            life: 6000,
          });
        }
      );

    } else if (this.kycId != undefined && this.hide === false) {
      delete documentData["city"];
      delete documentData["state"];
      if (this.selectedCardType == 'Pancard') {
        documentData["adharCardNumber"] = "";
      }
      else if (this.selectedCardType == 'Aadharcard') {
        documentData["panCardNumber"] = "";
      }

      this.submittedKyc = false;
      this.userService.addUserBankDetails(this.kycId, documentData).subscribe(
        (data) => {
          this.showMessage = true;
          this.submitted = false;
          this.showMessage = true;
          this.submitted = false;
          this.step = this.step + 1;
          this.activeIndex = this.activeIndex + 1;
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = "reload";
          this.router.navigate(["/kyc-update/" + this.kycId + "/" + this.step]);
        },
        (err) => {
          console.log(err);
          this.messageService.add({
            key: "toastmsg",
            severity: "error",
            summary: "Error",
            detail: err.error.message,
            life: 6000,
          });
        }
      );
    } else if (this.kycId != undefined && this.hide == true) {
      this.step = this.step + 1;
      this.activeIndex = this.activeIndex + 1;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = "reload";
      this.router.navigate(["/kyc-update/" + this.kycId + "/" + this.step]);

    }

  }
  onSubmit2() {
    this.submitted2 = true;
    //stop here if form is invalid
    if (this.kycUpdateForm2.invalid) {
      return;
    }
    this.step = this.step + 1;
    this.activeIndex = this.activeIndex + 1;
    let bankData = this.kycUpdateForm2.value;
    bankData["isDocumentComplete"] = true
    delete bankData["confirmAccountNumber"];
    // bankData["bankName"] = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(bankData["bankName"]), this.key, {
    //   keySize: 128 / 8,
    //   iv: this.iv,
    //   mode: CryptoJS.mode.CBC,
    //   padding: CryptoJS.pad.Pkcs7
    // }).toString();
    // bankData["accountNumber"] = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(bankData["accountNumber"]), this.key, {
    //   keySize: 128 / 8,
    //   iv: this.iv,
    //   mode: CryptoJS.mode.CBC,
    //   padding: CryptoJS.pad.Pkcs7
    // }).toString();
    // bankData["ifsc"] = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(bankData["ifsc"]), this.key, {
    //   keySize: 128 / 8,
    //   iv: this.iv,
    //   mode: CryptoJS.mode.CBC,
    //   padding: CryptoJS.pad.Pkcs7
    // }).toString();

    this.userService.addUserBankDetails(this.kycId, bankData).subscribe(
      (data) => {
        this.showMessage = true;
        this.submitted = false;
      },
      (err) => {
        console.log(err);
        this.messageService.add({
          key: "toastmsg",
          severity: "error",
          summary: "Error",
          detail: err.error.message,
          life: 6000,
        });
      }
    );
  }
  backToProfile() {
    if (this.isAcademy === true) {
      this.router.navigate(["/academies-profile"]);
    } else {
      this.router.navigate(["/profile-info"]);
    }

  }
  removeFile(event) {
    this.uploadedFiles = [];
    this.panCardImage = "{{imageProfile}}";
  }
  async getkyc(kycId) {
    this.userService.getUserKycDetails(kycId).subscribe(
      (dt) => {
        // 
        this.item = dt;
        this.count = Object.keys(dt).length;
        if (this.item && this.count != 0) {
          this.kycUpdateForm.get("state").setValue({
            name: this.item["statename"],
            id: this.item["statecode"],
          });
          this.getCities("false", this.item["statecode"]);

          if (this.item["citycode"]) {
            this.kycUpdateForm.get("city").setValue({
              name: this.item["cityname"],
              code: this.item["citycode"],
            });
          }

          if (this.item["panCardNumber"]) {
            this.selectedCardType = "Pancard";
            this.kycUpdateForm.get("panOrAadhar").setValue('Pancard');
          } else if (this.item["adharCardNumber"]) {
            this.selectedCardType = "Aadharcard";
            this.kycUpdateForm.get("panOrAadhar").setValue('Aadharcard');
          }
          this.kycUpdateForm.patchValue({
            panCardNumber: this.item["panCardNumber"],
            // CryptoJS.AES.decrypt(this.item["panCardNumber"], this.key, {
            //   keySize: 128 / 8,
            //   iv: this.iv, mode: CryptoJS.mode.CBC,
            //   padding: CryptoJS.pad.Pkcs7
            // }).toString(CryptoJS.enc.Utf8),
            adharCardNumber: this.item["adharCardNumber"],
            // CryptoJS.AES.decrypt(this.item["adharCardNumber"], this.key, {
            //   keySize: 128 / 8,
            //   iv: this.iv, mode: CryptoJS.mode.CBC,
            //   padding: CryptoJS.pad.Pkcs7
            // }).toString(CryptoJS.enc.Utf8),
            gstNumber: this.item["gstNumber"],
            //  CryptoJS.AES.decrypt(this.item["gstNumber"], this.key, {
            //   keySize: 128 / 8,
            //   iv: this.iv, mode: CryptoJS.mode.CBC,
            //   padding: CryptoJS.pad.Pkcs7
            // }).toString(CryptoJS.enc.Utf8),
            address: this.item["address"],
            zipcode: this.item["zipcode"],
          });
          this.stateCode = this.item['statecode'];
          this.stateName = this.item['statename'];
          this.cityCode = this.item['citycode'];
          this.cityName = this.item['cityname'];
          this.kycUpdateForm2.patchValue({
            bankName: this.item["bankName"],
            // CryptoJS.AES.decrypt(this.item["bankName"], this.key, {
            //   keySize: 128 / 8,
            //   iv: this.iv, mode: CryptoJS.mode.CBC,
            //   padding: CryptoJS.pad.Pkcs7
            // }).toString(CryptoJS.enc.Utf8),
            accountNumber: this.item["accountNumber"],
            // CryptoJS.AES.decrypt(this.item["accountNumber"], this.key, {
            //   keySize: 128 / 8,
            //   iv: this.iv, mode: CryptoJS.mode.CBC,
            //   padding: CryptoJS.pad.Pkcs7
            // }).toString(CryptoJS.enc.Utf8),
            confirmAccountNumber: this.item["accountNumber"],
            // CryptoJS.AES.decrypt(this.item["accountNumber"], this.key, {
            //   keySize: 128 / 8,
            //   iv: this.iv, mode: CryptoJS.mode.CBC,
            //   padding: CryptoJS.pad.Pkcs7
            // }).toString(CryptoJS.enc.Utf8),
            ifsc: this.item["ifsc"],
            // CryptoJS.AES.decrypt(this.item["ifsc"], this.key, {
            //   keySize: 128 / 8,
            //   iv: this.iv, mode: CryptoJS.mode.CBC,
            //   padding: CryptoJS.pad.Pkcs7
            // }).toString(CryptoJS.enc.Utf8),
          });
          if (this.item["pancardPic"] != undefined) {
            this.imageProfile = this.item["pancardPic"];
            this.showProfile = true;
          } else {
            this.showProfile = false;
          }

          if (this.item["bankName"]) {

            this.hide = true;

            this.kycUpdateForm.get("state").disable();
            this.kycUpdateForm.get("city").disable();
            this.kycUpdateForm.get("panCardNumber").disable();
            this.kycUpdateForm.get("panOrAadhar").disable();
            this.kycUpdateForm.get("adharCardNumber").disable();
            this.kycUpdateForm.get("gstNumber").disable();
            this.kycUpdateForm.get("address").disable();
            this.kycUpdateForm.get("zipcode").disable();
            this.kycUpdateForm2.get("bankName").disable();
            this.kycUpdateForm2.get("accountNumber").disable();
            this.kycUpdateForm2.get("ifsc").disable();
          }
        }
      },
      (err) => {
        this.messageService.add({
          key: "toastmsg",
          severity: "error",
          summary: "Error",
          detail: err.error.error,
          life: 6000,
        });
      }
    );
  }
}
